export const enum SupportChatEventMatch {
    Exact = 0,
    Fuzzy = 1
}
